import {createSelector} from 'reselect';
import { property, identity } from 'lodash';

export const getService = createSelector(property('service'), identity);
export const isLoaded = createSelector(getService, property('isLoaded'));
export const getError = createSelector(getService, property('error'));



// WEBPACK FOOTER //
// ./src/modules/ServiceDetail/selectors/index.js